export default {
  path: '/wecode/:type/popularizeList',
  auth: true,
  preload: false,
  key: 'popularize',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: (props) => import('./index')
};
